"use strict";

angular
	.module('rmToolbar')
	.controller('AppToolbarCtrl', require('./toolbar_ctrl'))